import React, { FunctionComponent } from "react"
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core"
import { useBatchPageContext } from "../useBatchPageContext"
import { Fields, updateSelect } from "../reducer"
import styles from "./FileFormats.module.scss"

export const FileFormats: FunctionComponent = props => {
    const { state, dispatch } = useBatchPageContext()
    const { audioFormatOptions, fields } = state

    return (
        <>
            <FormControl
                variant="outlined"
                id="select-file-format-control"
                data-testid="file-format-select"
                className={styles.Select}
            >
                <InputLabel id="select-file-format-label" htmlFor={"file-format"}>
                    File Format
                </InputLabel>
                <Select
                    id="file-format"
                    labelId="select-file-format-label"
                    label="File Format"
                    inputProps={{ "data-testid": "select-file-format" }}
                    value={fields.fileFormat.value}
                    onChange={(e: any) => {
                        dispatch(updateSelect(Fields.FileFormat, e.target.value))
                    }}
                >
                    {Object.values(audioFormatOptions).map(format => {
                        return (
                            <MenuItem key={format.id} value={format.id}>
                                {format.name}
                            </MenuItem>
                        )
                    })}
                </Select>
            </FormControl>
        </>
    )
}
